import React from "react";

const PatientVitals=()=>{

    return(
        <>
        </>
    )
}

export default PatientVitals